<template>
  <div class>
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="GroupViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{group.name}}</p>
                <p style="font-size:15px">Asset Count: {{assetCount}}</p>
                <br />
                <button v-on:click="edit" type="button" class="btn btn-default form-group">Edit</button>
              </div>
            </div>
            <!--Editing-->
            <div class="GroupEditing col-md-5" v-show="isEditing">
              <form-text
                ref="groupname"
                styler="font-size:35px"
                label="Group Name"
                name="groupname"
                v-model="groupEdit.name"
                validation="required"
              ></form-text>
              <br />
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn btn-success">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import VueMask from "v-mask";
import VueFire from "vuefire";
import FormText from "../../elements/Form/FormText";
import FormTextMask from "../../elements/Form/FormTextMask";
import FormTextArea from "../../elements/Form/FormTextArea";
import database from "../../webmaster/Database/database";

import store from "../../../components/webmaster/Store/vuex";

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: "groupdetail",
  components: {
    "form-text": FormText,
    "form-textarea": FormTextArea
  },
  data() {
    return {
      group: "",
      groupEdit: "",
      assetCount: 0,
      isEditing: false
    };
  },
  created: function() {
    this.fetchGroup();
  },
  methods: {
    edit: function() {
      this.isEditing = true;
    },
    cancelEdit: function() {
      this.isEditing = false;
    },
    submitEdit: function() {},
    fetchGroup: function() {
      let orgId = this.$store.state.usermain.curOrg.id;
      let groupId = this.$route.params.id;

      let self = this;

      let doc = database.getFireStoreDoc('orgs/' + orgId + '/groups/' +  groupId);

      doc.get().then(function(doc) {
        if (doc.exists) {
            self.group = doc.data();
            self.groupEdit = doc.data();

        } else {
            // doc.data() will be undefined in this case
            console.log("No such document at!");
        }
      });

      console.log("orgs/" + orgId + "/groups/" + groupId + "/assets/");

      let collection = database.getFireStoreColl("orgs/" + orgId + "/groups/" + groupId + "/assets/");

      collection.get().then(function(querySnapshot) {
        //TODO: FIX DIS DIS BAD THE GROUP SHOULD HAVE AN INCREMENTED VARIABLE UNDER IT
        self.assetCount = querySnapshot.docs.length;
      });

      console.log("Imma done");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// GroupDetail.vue?f7d6d0e0